import * as Icons from "lucide-react";
import { COMPANY, openWhatsApp, LOGO_URL } from "@/lib/site";

const cols = [
  {
    title: "Company",
    links: [
      { label: "About", href: "#about" },
      { label: "Portfolio", href: "#portfolio" },
      { label: "Technologies", href: "#technologies" },
      { label: "Industries", href: "#industries" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Web & Software", href: "#services" },
      { label: "Cloud Solutions", href: "#services" },
      { label: "AI Automation", href: "#services" },
      { label: "Data Analytics", href: "#services" },
      { label: "Digital Marketing", href: "#services" },
    ],
  },
];

const socials = [
  { icon: "Facebook", href: "https://facebook.com/Clomedix.Tech", label: "Facebook" },
  { icon: "Instagram", href: "https://www.instagram.com/clomedixtech/", label: "Instagram" },
  { icon: "Youtube", href: "https://www.youtube.com/@ClomedixTech", label: "YouTube" },
];

export const Footer = () => (
  <footer className="bg-slate-50 border-t border-slate-100 pt-20 pb-8" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="lg:col-span-1">
          <div className="mb-4">
            <img
              src={LOGO_URL}
              alt="ClomedixTech — Digital Software Service Solutions"
              className="h-28 w-auto object-contain"
            />
          </div>
          <p className="text-sm text-slate-600 leading-relaxed max-w-xs">
            A premium digital partner for startups, SMEs and enterprises — engineered for growth.
          </p>
          <div className="flex items-center gap-3 mt-6">
            {socials.map((s) => {
              const Icon = Icons[s.icon];
              return (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white border border-slate-200 text-slate-600 hover:text-white hover:bg-brand-gradient hover:border-transparent transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              );
            })}
          </div>
        </div>

        {cols.map((col) => (
          <div key={col.title}>
            <div className="font-heading font-bold text-slate-900 mb-4">{col.title}</div>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-slate-600 hover:text-slate-900 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <div className="font-heading font-bold text-slate-900 mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-slate-600">
            <li>
              <a href={`mailto:${COMPANY.email}`} className="hover:text-slate-900 flex items-center gap-2" data-testid="footer-email-link">
                <Icons.Mail className="w-4 h-4" /> {COMPANY.email}
              </a>
            </li>
            <li>
              <a href={COMPANY.whatsappUrl} target="_blank" rel="noopener noreferrer" onClick={openWhatsApp} className="hover:text-slate-900 flex items-center gap-2" data-testid="footer-whatsapp-link">
                <Icons.MessageCircle className="w-4 h-4" /> {COMPANY.whatsappNumber}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Icons.Globe2 className="w-4 h-4 mt-0.5" />
              <span>Remote-first · Serving clients worldwide</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200 mt-16 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
        <div>© 2026 ClomedixTech. All Rights Reserved.</div>
        <div className="flex items-center gap-6">
          <a href="#" className="hover:text-slate-900">Privacy</a>
          <a href="#" className="hover:text-slate-900">Terms</a>
          <a href="#" className="hover:text-slate-900">Cookies</a>
        </div>
      </div>
    </div>
  </footer>
);
